<template>
	<div class="EWarehousList">
		<div class="tit">
			<span>{{Language.LG.InventoryList[isLanguage]}}</span>
		</div>
		<div class="list">
			<div class="item" v-for="(item,index) in OrdersData" :key="index">
				<div>
					<div class="itName">
						<span class="itText">{{Language.LG.WareBoxNo[isLanguage]}}:<span class="it-Cont">{{item.boxNum}}</span></span>
						<span class="itText">{{Language.LG.WareReceNum[isLanguage]}}:<span class="it-Cont">{{item.t_package_no}}</span></span>
						<span class="itText">{{Language.LG.WareStoTime[isLanguage]}}:<span class="it-Cont">{{item.rent_time}}</span></span>
					</div>
					<div class="itTips">
						<span class="itText" v-if="item.box_style == '5'">{{Language.LG.WareBoxSize[isLanguage]}}:<span>{{Language.LG.SmallBox[isLanguage]}}</span></span>
						<span class="itText" v-else-if="item.box_style == '6'">{{Language.LG.WareBoxSize[isLanguage]}}:<span>{{Language.LG.MedBox[isLanguage]}}</span></span>
						<span class="itText" v-else-if="item.box_style == '7'">{{Language.LG.WareBoxSize[isLanguage]}}:<span>{{Language.LG.BigBoxRd[isLanguage]}}</span></span>
						<span class="itText itEm">{{Language.LG.WareInStorage[isLanguage]}}</span>
					</div>
				</div>
				<!-- <checkbox class="itCheckbox" value="1"/> -->
			</div>
			
		</div>
		
		<!--按钮组-->
		<EConfigBtn :pushBg="'#151c36'" :backUp="backUp" :quit="quit"></EConfigBtn>
	</div>
</template>

<script>
	import EConfigBtn from '../assets/ConfigBtn.vue'
	import { EloginApi } from '../../../../static/CESite40s/js/api.js'
	import { conLog,storage } from '../../../../static/js/utils/utility.js'
	var vm
	export default {
		data() {
			return {
				configStorage:null,
				userInfo:null,
				
				OrdersData:[],//入库数据
				
				isLanguage:0,
				Language:'',
				
				routeType:'',//路由类型
			};
		},
		async created(){
			vm = this
			var configStorage = storage.localGetItem('configStorage');
			if(configStorage){
				this.configStorage = configStorage
			}
			var userInfo = storage.localGetItem('userInfo');
			if(userInfo){
				this.userInfo = userInfo
			}
			
			var isLanguage = storage.localGetItem('isLanguage');
			if(isLanguage){
				this.isLanguage = isLanguage
			}
			this.Language = this.$Language
			
			this.routeType = vm.$route.query.type
			
			this.getStoragedOrders()
		},
		components:{
			EConfigBtn,
		},
		methods:{
			//获取已入库的订单
			async getStoragedOrders(){
				let data = {
					'cabinet_id':vm.configStorage.deviceId,//设备id
					'sender_phone':vm.userInfo.phone_no,//派件人电话
					'first_row':0,//当前页,从0开始
					'list_rows':9999,//每页数量
				}
				conLog('订单列表',data)
				let res = await EloginApi.getStoragedOrders(data)
				if(res){
					if(res.meta.code == 200){
						conLog('订单列表',res)
						for(var i in res.body){
							res.body[i].boxNum = res.body[i].box_id.replace(vm.configStorage.deviceId,"");
						}
						vm.OrdersData = res.body
					}else{
						vm.$message({
							message: res.meta.message,
							type: 'error',
							duration:1000
						});
					}
				}
			},
			//返回上一页
			backUp(){
				console.log(vm.routeType)
				vm.$router.push({
					path:'/CEsite40s/EWarehousList',
					query:{
						'type': vm.routeType
					}
				})
			},
			//退出登录
			quit(){
				vm.$router.push({
					path:'/CEsite40s',
				})
			}
		}
	}
</script>

<style lang="less">
.EWarehousList{
	.list{
		background: #fff;
		overflow: auto;
		height: calc(100vh - 1.98rem);
		.item{
				color: #151c36;
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 0.2rem;
				border-bottom: 0.02rem solid #555;
				.itCheckbox{
					margin-right: 0.2rem;
				}
				.itName{
					font-size: 0.36rem;
					margin-bottom: 0.1rem;
				}
				.itTips{
					font-size: 0.3rem;
					color: #888;
					.itEm{
						background: #009688;
						color: #fff;
						border-radius: 0.1rem;
						padding: 0.05rem 0;
					}
				}
				.itText{
					margin-right: 0.7rem;
					.it-Cont{
						font-style: normal;
						margin-left: 0.3rem;
					}
				}
			}
		}
	.tit{
		position: relative;
		background: #151c36;
		height: 1.2rem;
		line-height: 1.2rem;
		font-size: 0.45rem;
		text-align: center;
		.wareLog{
			font-size: 0.3rem;
			line-height: 1;
			position: absolute;
			right: 0.3rem;
			top: 48%;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/CEsite40s/StoRecords/StoRecords.vue